import * as d3 from 'd3-selection'
import { interpolate } from 'd3-interpolate'
import yPos from './y-text-position.js'
import interpolator from 'rounding-interpolator'

export default function (d, dim) {
  var i = interpolator(this.textContent, d)
    , endFont = parseFloat(d3.select(this).attr('data-fs'))
    , j = interpolate(parseFloat(d3.select(this).style('font-size')) || endFont, endFont)
    , yEnd = yPos(endFont, dim.header.height)
    , k = interpolate(d3.select(this).attr('y') || yEnd, yEnd)
    , node = this

  return function (t) {
    node.textContent = i(t)
    d3.select(node)
      .style('font-size', Math.round(j(t)) + 'px')
      .attr('y', k(t))
  }
}
